import React from "react";

import { getLabel } from "src/utils/checklist";

import type { ChecklistFieldNotification } from "src/types";

import Values from "../Values";
import { Field as StyledField, FieldLabel } from "./styles";

type Props = {
  field: ChecklistFieldNotification;
  timestamp: string;
  fieldId: number;
  form?: boolean;
  invertBackground?: boolean;
};

const Field = ({
  field,
  timestamp,
  fieldId,
  form = false,
  invertBackground = false,
}: Props) => {
  const label = getLabel(field.type);
  return (
    <StyledField form={form} invertBackground={invertBackground}>
      <FieldLabel>{label}</FieldLabel>
      <Values field={field} timestamp={timestamp} fieldId={fieldId} />
    </StyledField>
  );
};

export default Field;
